import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { OrderItem } from './Orders';

import AdminTitle from '../../components/AdminTitle';
import Api from '../../Api';

export default class AdminQueue extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = {
      orders: null
    };
  }

  componentDidMount() {
    let orders = Api.cache.getOrderList();
    if (orders) {
      this.setState(orders);
    } else {
      this.loadOrders();
    }
  }

  loadOrders() {
    Api.getOrders().then(
      (orders) => {
        this.setState(orders);
      },
      (error) => {
        this.setState({error});
      }
    );
  }

  onChange(event) {
    let payload = {};
    payload[event.target.name] = event.target.value;
    this.setState(payload)
  }

  render() {
    return (
      <div className="order-list">
        <AdminTitle title="Queue" />
        <Tabs>
          <TabList>
            <Tab>New Orders</Tab>
            <Tab>Waiting On Shipping</Tab>
            <Tab>Shipped</Tab>
            <Tab>Requested Returns</Tab>
          </TabList>
          <TabPanel>
            {this.filterOrders('WAITING_ON_ORDER')}
          </TabPanel>
          <TabPanel>
            {this.filterOrders('WAITING_ON_SHIPPING')}
          </TabPanel>
          <TabPanel>
            {this.filterOrders('SHIPPED')}
          </TabPanel>
          <TabPanel>
            {this.filterOrders('RETURN_REQUESTED')}
          </TabPanel>
        </Tabs>
      </div>
    );
  }

  filterOrders(orderItemState) {
    let orders;
    if (!this.state.orders) {
      orders = <FontAwesome name="refresh" spin/>
    } else {
      let orderList = this.state.orders;
      orders = orderList
        .filter((order) => {
          return order.items.filter((item) => { return item.state === orderItemState; }).length > 0
            && order.state !== 'FAILED' && order.state !== 'CANCELED';
        })
        .map((order) => {
        return <OrderItem key={order.token} order={order} retailers={this.state.retailers} users={this.state.users}
                          loadOrders={this.loadOrders}/>
      });
    }
    return orders;
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminQueue.js
 **/